import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiShield,FiAward,FiUsers,FiTrendingUp,FiStar,FiCheckCircle,FiClock,FiGlobe}=FiIcons;

const TrustBadges=()=> {
  const badges=[
    {
      icon: FiAward,
      title: "Superhost Airbnb",
      description: "Certificazione ufficiale per eccellenza nel servizio"
    },
    {
      icon: FiStar,
      title: "Partner Booking.com",
      description: "Partner preferito con rating superiore a 9.0"
    },
    {
      icon: FiShield,
      title: "Assicurazione Completa",
      description: "Copertura danni fino a €50.000 per ogni prenotazione"
    },
    {
      icon: FiUsers,
      title: "150+ Clienti Attivi",
      description: "Proprietari che si fidano della nostra gestione"
    },
    {
      icon: FiTrendingUp,
      title: "+45% Ricavi Medi",
      description: "Aumento medio documentato sui nostri immobili"
    },
    {
      icon: FiCheckCircle,
      title: "98% Soddisfazione",
      description: "Tasso di soddisfazione clienti verificato"
    },
    {
      icon: FiClock,
      title: "Assistenza H24/7",
      description: "Supporto continuo per ospiti e proprietari"
    },
    {
      icon: FiGlobe,
      title: "Mercato Internazionale",
      description: "Gestione multilingue per ospiti da tutto il mondo"
    }
  ];

  const platforms=[
    {
      name: "Airbnb",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Airbnb_Logo_B%C3%A9lo.svg/2560px-Airbnb_Logo_B%C3%A9lo.svg.png",
      description: "La piattaforma leader mondiale per affitti brevi"
    },
    {
      name: "Booking.com",
      logo: "https://logos-world.net/wp-content/uploads/2021/08/Booking-Logo.png",
      description: "Il portale di prenotazioni più utilizzato al mondo"
    }
  ];

  return (
    <>
      {/* Main Trust Badges */}
      <section className="py-16 bg-white border-b border-warm-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.6}}
            viewport={{once: true}}
            className="text-center mb-12"
          >
            <h2 className="text-2xl md:text-3xl font-bold text-warm-900 mb-4">
              Perché Scegliere Elvira Vigliano Property Manager
            </h2>
            <p className="text-warm-600 max-w-2xl mx-auto">
              Certificazioni,risultati e garanzie che testimoniano la nostra eccellenza nel settore
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {badges.map((badge,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,y: 20}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.6,delay: index * 0.1}}
                viewport={{once: true}}
                className="text-center p-6 bg-warm-50 rounded-xl hover:shadow-lg transition-all duration-200 group"
              >
                <div className="bg-primary-50 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-100 transition-colors">
                  <SafeIcon icon={badge.icon} className="h-6 w-6 text-primary-600" />
                </div>
                <h3 className="font-bold text-warm-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {badge.title}
                </h3>
                <p className="text-sm text-warm-600 leading-relaxed">
                  {badge.description}
                </p>
              </motion.div>
            ))}
          </div>

          {/* Stats Row - REMOVED */}
        </div>
      </section>

      {/* Platforms Section */}
      <section className="py-12 bg-gradient-to-r from-primary-50 to-warm-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.6}}
            viewport={{once: true}}
            className="text-center mb-8"
          >
            <h3 className="text-xl font-bold text-warm-900 mb-2">
              Presenza su Tutte le Principali Piattaforme
            </h3>
            <p className="text-warm-600">
              Il tuo immobile sarà visibile sui portali di prenotazione più importanti al mondo
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
            {platforms.map((platform,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,y: 20}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.6,delay: index * 0.1}}
                viewport={{once: true}}
                className="bg-white rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow group"
              >
                <div className="h-16 flex items-center justify-center mb-4">
                  <img 
                    src={platform.logo} 
                    alt={`${platform.name} logo`}
                    className="max-h-12 max-w-full object-contain group-hover:scale-105 transition-transform"
                  />
                </div>
                <h4 className="font-bold text-warm-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {platform.name}
                </h4>
                <p className="text-xs text-warm-600">
                  {platform.description}
                </p>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{opacity: 0}}
            whileInView={{opacity: 1}}
            transition={{duration: 0.6,delay: 0.4}}
            viewport={{once: true}}
            className="text-center mt-8"
          >
            <div className="bg-white/70 backdrop-blur-sm rounded-xl p-4 inline-block">
              <p className="text-sm text-warm-700 flex items-center justify-center">
                <SafeIcon icon={FiShield} className="h-4 w-4 mr-2 text-primary-600" />
                <strong>Massima Visibilità:</strong>&nbsp;Oltre 20 piattaforme internazionali per raggiungere milioni di viaggiatori
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default TrustBadges;